import { kUserFilesApiBasePath } from '@/constants/constants-api-paths'
import { kUserFilesDeleteSelectionMaxFileIds, kUserFilesDeleteSelectionMaxFolderIds } from '@/user_files/limits'

export const kUserFilesDeleteApiBasePath = `${kUserFilesApiBasePath}/delete`

// Backend request limits, shared by the delete and delete-preview requests
export const kDeleteMaxFileIdsPerRequest = kUserFilesDeleteSelectionMaxFileIds
export const kDeleteMaxFolderIdsPerRequest = kUserFilesDeleteSelectionMaxFolderIds
